import { Outlet, useLocation } from "react-router-dom";
import { useEffect, ReactNode } from "react";
import { Header } from "./Header";
import { Footer } from "./Footer";

import { WhatsAppButton } from "./WhatsAppButton";

interface SiteLayoutProps {
  children?: ReactNode;
}

export function SiteLayout({ children }: SiteLayoutProps) {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <main className="flex-1">
        {children || <Outlet />}
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}
